import React from 'react'
import { BuildProjectLabels } from 'src/types'
import {
    ContentSection,
    DirectionContent,
    Image,
    OverCard,
    OverSpan,
    Section,
    TypographySection,
    Refer,
} from './styles'

export const MapCard = ({
    title,
    background,
    phases,
    image,
    link,
    addressOver,
}: BuildProjectLabels) => {
    return (
        <DirectionContent address={addressOver}>
            <Refer href={link}>
                <OverCard
                    background={background}
                    marginRight={['xmedium', 'xmedium', 'xxxsmall', 'large']}
                    marginLeft={['xmedium', 'xmedium', 'xxxsmall', 'large']}
                    marginTop={['xmedium', 'xmedium', 'xxxsmall', 'large']}
                >
                    <OverSpan></OverSpan>
                    <Section>
                        <Image src={image} alt={title} />
                        <TypographySection>
                            <ContentSection
                                variant={'h2'}
                                fontSize={'medium'}
                                fontWeight={400}
                            >
                                {phases}
                            </ContentSection>
                            <ContentSection
                                variant={'h3'}
                                fontSize={'xxxsmall'}
                                fontWeight={600}
                            >
                                {title}
                            </ContentSection>
                        </TypographySection>
                    </Section>
                </OverCard>
            </Refer>
        </DirectionContent>
    )
}
